import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { LayoutDrawerComponent } from './components/layout/layout-drawer.component';
import { ReviewFieldsComponent } from './components/fields/review-fields.component';
import { InputFieldComponent } from './components/fields/input-field/input-field.component';
import { DisplayFieldsComponent } from './components/fields/display-field/display-fields.component';
import { ReviewTablesComponent } from './components/tables/review-tables.component';
import { ReviewStaticTablesComponent } from './components/static-tables/review-static-tables.component';
import {
	ReviewTableColumnOptionsPipe,
	ReviewNestedTableOptionsPipe,
	OnlyRealColumnsPipe,
	ReplaceIndexFromOptionsPipe,
	ReplacePointerIndexFromOptionsPipe
} from './components/pipes/tables.pipe';
import { CvComponentLibraryModule } from '@cv-invision/cv.component-library.ux';
import { EnumerationExcludeFilterPipe } from './components/pipes/enumeration-exclude.pipe';

@NgModule({
	declarations: [
		ReviewFieldsComponent,
		ReviewTablesComponent,
		ReviewStaticTablesComponent,
		LayoutDrawerComponent,
		InputFieldComponent,
		DisplayFieldsComponent,
		ReviewTableColumnOptionsPipe,
		ReviewNestedTableOptionsPipe,
		OnlyRealColumnsPipe,
		ReplaceIndexFromOptionsPipe,
		ReplacePointerIndexFromOptionsPipe,
		EnumerationExcludeFilterPipe,
	],
	entryComponents: [
		LayoutDrawerComponent,
		ReviewFieldsComponent,
		InputFieldComponent,
		DisplayFieldsComponent,
		ReviewTablesComponent,
		ReviewStaticTablesComponent
	],
	exports: [
		LayoutDrawerComponent,
		ReviewFieldsComponent,
		InputFieldComponent,
		DisplayFieldsComponent,
		ReviewTablesComponent,
		ReviewStaticTablesComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		CvComponentLibraryModule
	]
})
export class SectionsReviewModule { }
